var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_12",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(9.132 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.13, -6)",
    filter: "url(#Ellipse_12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12-2",
    "data-name": "Ellipse 12",
    transform: "translate(9 6)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M14.811,6.722c.01.147.01.293.01.44A9.56,9.56,0,0,1,5.2,16.788,9.561,9.561,0,0,1,0,15.27a7,7,0,0,0,.817.042,6.776,6.776,0,0,0,4.2-1.446A3.389,3.389,0,0,1,1.854,11.52a4.267,4.267,0,0,0,.639.052,3.578,3.578,0,0,0,.89-.115A3.384,3.384,0,0,1,.67,8.136V8.094A3.407,3.407,0,0,0,2.2,8.524,3.388,3.388,0,0,1,1.152,4a9.617,9.617,0,0,0,6.976,3.54,3.819,3.819,0,0,1-.084-.775A3.387,3.387,0,0,1,13.9,4.449a6.661,6.661,0,0,0,2.147-.817A3.374,3.374,0,0,1,14.56,5.5a6.783,6.783,0,0,0,1.948-.524A7.273,7.273,0,0,1,14.811,6.722Z",
    transform: "translate(10.284 8.77)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.44a53e1ae6c8ad5119f4c3defd2305cf.svg";
export { ForwardRef as ReactComponent };